/**
 * Exams and Unit Tests are one backend module (`/exam-v2`) separated by a
 * `type` discriminator. The screens below are shared; only these labels and the
 * `type` sent to the API differ, which is what keeps the two menu entries
 * feeling like distinct features without duplicating any code.
 */
export const ASSESSMENT_TYPES = {
  exam: "exam",
  unit_test: "unit_test",
};

const LABELS = {
  exam: { one: "Exam", many: "Exams", upper: "EXAMS" },
  unit_test: { one: "Unit Test", many: "Unit Tests", upper: "UNIT TESTS" },
};

export const labelsFor = (type) => LABELS[type] || LABELS.exam;
